import {FileRecord} from "../file/FileRecord";

export class WorkflowStepLibraryPostSequencingSavSummaryModel {

  yieldTotalRead1: number;
  yieldTotalRead4: number;

  projectedYieldRead1: number;
  projectedYieldRead4: number;

  alignedRead1: number;
  alignedRead4: number;

  errorRateRead1: number;
  errorRateRead4: number;

  intensityCycle1Read1: number;
  intensityCycle1Read4: number;

  intensityCycle1PercentRead1: number;
  intensityCycle1PercentRead4: number;

  q30PercentRead1: number;
  q30PercentRead4: number;

  densityRead1: string;
  densityRead4: string;

  occupiedRead1: string;
  occupiedRead4: string;

  pfPercentRead1: string;
  pfPercentRead4: string;

  readsMRead1: number;
  readsMRead4: number;

  readsPfMRead1: number;
  readsPfMRead4: number;

  yieldGbRead1: number;
  yieldGbRead4: number;

  alignedWithErrorRead1: string;
  alignedWithErrorRead4: string;

  importedFile: FileRecord;

  static fromData(data: WorkflowStepLibraryPostSequencingSavSummaryModel): WorkflowStepLibraryPostSequencingSavSummaryModel {
    if (!data) return null;
    const obj = Object.assign(new WorkflowStepLibraryPostSequencingSavSummaryModel(), data);
    obj.importedFile = FileRecord.fromData(data.importedFile);
    return obj;
  }

}
